import React, { Component } from 'react';

const withReference = (requests, dataName) => BaseComponent =>
  class extends Component {
    state = {
      data: []
    };
    componentDidMount() {
      this.getRequest();
    }

    getRequest = () => {
      const data = [];
      Promise.all(requests).then(results => {
        results.forEach((result, i) => {
          data[ dataName[ i ] ] = result;
        });
        this.setState({
          data: { ...data }
        });
      });
    };

    render() {
      const { data } = this.state;
      return <BaseComponent data={ data } { ...this.props } />;
    }
  };

export default withReference;
